import React from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import './VideoSlider.css';
import VideoModal from "./VideoModal";

const VideoSlider = () => {
    const params = {
        slidesPerView: 1,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    }
    const [modalShow, setModalShow] = React.useState(false);
    const [videoid, setVideoId] = React.useState('');
    function openModal(e, videoName) {
        e.preventDefault();
        setModalShow(true);
        setVideoId(videoName)
    }
    const videos = {
        "home": [
            {
                "videoUrl": "Q-VoLCxt05M"
            },
            {
                "videoUrl": "fbStXZgX18g"
            }
        ],
        "ongroundchallenge": [
            {
                "videoUrl": "1zDkqXl2DGI"
            },
            {
                "videoUrl": "CioKj2g_bA4"
            }
        ]
    }
    let videoList;
    let pathName = window.location.pathname;
    if (pathName === '/ongroundchallenge') {
        videoList = videos.ongroundchallenge
    } else {
        videoList = videos.home
    }

    return (
        <div>
            <Swiper {...params}>
                {videoList.map((item, i) => {
                    let vUrl = 'https://img.youtube.com/vi/' + item.videoUrl + '/maxresdefault.jpg'
                    return (<div key={i}>
                        <a className="video-thumb-link" href="#" onClick={(e) => openModal(e, `${item.videoUrl}`)}>
                            <div className="video-thumb">
                                <img src={vUrl} className="img-fluid" alt="" />
                            </div>
                        </a>
                    </div>)
                })}
            </Swiper>
            <VideoModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                videoid={videoid}
            />
        </div>
    )
};

export default VideoSlider;